import React from 'react';
import PropTypes from 'prop-types';

const StepperContentList = ({ children }) => (
  <div className="ws-stepper__content-list">{children}</div>
);

StepperContentList.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StepperContentList;
